import * as t from './action_types';
import { apiAction } from '../../api/store/actions';
import {
    makeActionCreator,
    makeActionCreatorObjParam,
} from '@trumedianetworks/tmn-core-components/src/util/redux-helpers';

const baseUrl = process.env.VIDEO_SERVICE_BASE_URL || 'https://intern.trumedianetworks.com/';

const setPackageList = makeActionCreator(t.SET_PACKAGE_LIST, 'data');
const setPackage = makeActionCreator(t.SET_PACKAGE, 'data');
export const selectPackage = makeActionCreatorObjParam(t.SELECT_PACKAGE, 'packageId');
export const unselectAllPackages = makeActionCreatorObjParam(t.UNSELECT_ALL_PACKAGES);

export const setFilter = makeActionCreator(t.SET_FILTER, 'filter');

export const setPackageListIsLoading = makeActionCreator(t.SET_PACKAGE_LIST_IS_LOADING);

export const fetchPackageList =
    (sitename, filters = {}) =>
    (dispatch) => {
        dispatch(setPackageListIsLoading());
        dispatch(
            apiAction({
                url: `${baseUrl}autodeploy/api/content/package/search`,
                method: 'GET',
                data: { ...filters, sitename },
                withCredentials: false,
                onSuccess: (rows) => {
                    dispatch(setPackageList(rows));
                },
                onFailure: (err) => {
                    console.error(err);
                },
            })
        );
    };

export const retryPackage = (id) => (dispatch) => {
    dispatch(
        apiAction({
            url: `${baseUrl}autodeploy/api/content/package/retry`,
            method: 'PUT',
            data: { id },
            withCredentials: false,
            onSuccess: (row) => {
                dispatch(setPackage(row));
            },
            onFailure: (err) => {
                console.error(err);
            },
        })
    );
};

export const fetchPackageDetails = (id) => (dispatch) => {
    dispatch(
        apiAction({
            url: `${baseUrl}autodeploy/api/content/package/details`,
            method: 'GET',
            data: { id },
            withCredentials: false,
            onSuccess: (row) => {
                dispatch(setPackage(row));
            },
            onFailure: (err) => {
                console.error(err);
            },
        })
    );
};
